import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"

const CustomerCarousel = ({ className }) => {
	return (
		<div className={className}>
			<div className="relative overflow-x-hidden flex ">
				{["animate-marquee", "animate-marquee2 absolute"].map((item, outerIndex) => {
					return (
						<div
							key={`logo-${item}`}
							className={`whitespace-nowrap items-center justify-center flex ${item}`}>
							<StaticImage
								src={`../images/customers/gms.png`}
								alt="GMS"
								title="GMS"
								placeholder="blurred"
								layout="fixed"
								height={50}
								className="mx-[32px] md:mx-[64px] inline-block"
							/>
							<StaticImage
								src={`../images/customers/atlantic-lloyd.png`}
								alt="Atlantic Lloyd"
								title="Atlantic Lloyd"
								placeholder="blurred"
								layout="fixed"
								height={50}
								className="mx-[32px] md:mx-[64px] inline-block"
							/>
							<StaticImage
								src={`../images/customers/tom-woerden.png`}
								alt="Schiffahrtskontor tom Wörden"
								title="Schiffahrtskontor tom Wörden"
								placeholder="blurred"
								layout="fixed"
								height={50}
								className="mx-[32px] md:mx-[64px] inline-block"
							/>
							<StaticImage
								src={`../images/customers/pd.png`}
								alt="Peter Döhle Schiffahrts KG"
								title="Peter Döhle Schiffahrts KG"
								placeholder="blurred"
								layout="fixed"
								height={50}
								className="mx-[32px] md:mx-[64px] inline-block"
							/>
							<StaticImage
								src={`../images/customers/nsc.png`}
								alt="NSC Holding GmbH & Cie. KG"
								title="NSC Holding GmbH & Cie. KG"
								placeholder="blurred"
								layout="fixed"
								height={50}
								className="mx-[32px] md:mx-[64px] inline-block"
							/>
							<StaticImage
								src={`../images/customers/island-view-ship-management.png`}
								alt="Island View Shipping"
								title="Island View Shipping"
								placeholder="blurred"
								layout="fixed"
								height={50}
								className="mx-[32px] md:mx-[64px] inline-block"
							/>
						</div>
					)
				})}
				<div className="pointer-events-none absolute inset-y-0 left-0 w-1/6 bg-gradient-to-r from-white"></div>
				<div className="pointer-events-none absolute inset-y-0 right-0 w-1/6 bg-gradient-to-l from-white"></div>
			</div>
		</div>
	)
}

export default CustomerCarousel
